import type { FC } from "react";

import { TrustedPlaces as UITrustedPlaces } from "@jti/loyalty/components/TrustedPlaces";

import type { trustedPlacesInputs } from "./TrustedPlaces.builder";

type TrustedPlacesBuilderProps = BuilderComponentProps<typeof trustedPlacesInputs>;

export const TrustedPlaces: FC<TrustedPlacesBuilderProps> = (props) => {
  return <UITrustedPlaces {...props} />;
};
